

































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getComment } from '../api/api';
let timer: any = null;

@Component
export default class CommentList extends Vue {
  @Prop() locationId!: number;
  voteName: string = '2019poject/2019new70years';
  commentList = [];
  copyList = true;
  async created() {
    const res = await getComment(this.voteName, this.locationId);
    if ((res as any).code === 200 && res.data.length > 0) {
      this.commentList = res.data;
      timer = setInterval(() => this.rollStart(), 50);
    }
  }
  rollStart() {
    const box = this.$refs.box;
    const list1 = this.$refs.list1;
    const list2 = this.$refs.list2;
    // console.log('1', (box as HTMLElement).scrollTop);
    if ((box as HTMLElement).scrollHeight / 2 < 400) {
      this.copyList = false;
    } else {
      if (
        (box as HTMLElement).scrollTop ===
        Math.floor((box as HTMLElement).scrollHeight / 2 - 22)
      ) {
        (box as HTMLElement).scrollTop = 0;
      } else {
        (box as HTMLElement).scrollTop++;
      }
    }
  }
  destroyed() {
    clearInterval(timer);
  }
}
